import { render, staticRenderFns } from "./InstallDesc.vue?vue&type=template&id=016c547c&scoped=true"
import script from "./InstallDesc.vue?vue&type=script&lang=js"
export * from "./InstallDesc.vue?vue&type=script&lang=js"
import style0 from "./InstallDesc.vue?vue&type=style&index=0&id=016c547c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c547c",
  null
  
)

export default component.exports